export default {
  translation: {
    membershipPlan: {
      dayPass: {
        "1": "High-speed Wi-Fi & full amenity access",
        "2": "Complimentary coffee",
      },
      virtualAddress: {
        "1": "Business address registration",
        "2": "Mail receipt & storage (up to 30 days)",
      },
      silver: {
        "1": "Unlimited open-seat coworking + US address",
        "2": "Priority pass to every event",
        "3": "5 hrs meeting rooms + 100 prints / month",
        "4": "Member directory + community channel",
        "5": "15% off on arclow services (year 1)",
        "6": "50% off the first year, reverts to $330/mo at renewal",
      },
    },
    apply: {
      pageTitle: "82 Office Application",
      onlyEnglishDescription: "Please enter all information in English",
      company: {
        label: "Company name",
        placeholder: "Enter company name",
      },
      representative: {
        firstName: {
          label: "Representative first name",
          placeholder: "Enter representative first name",
        },
        lastName: {
          label: "Representative last name",
          placeholder: "Enter representative last name",
        },
      },
      phone: {
        label: "Phone number",
      },
      email: {
        label: "Email",
        placeholder: "Enter email",
        required: "Email is required",
        invalid: "Enter a valid email address",
      },
      plan: {
        label: "Membership plan",
        priceUnit: {
          year: "year",
          month: "month",
          day: "day",
        },
        discount: "50% off",
      },
      terms: {
        title: "Membership terms of service",
        agree: "Agreement to Terms of Service",
        required: "(Required)",
      },
      payment: {
        title: "Payment",
        amountTitle: "Payment amount",
        total: "Total",
        popupWarning:
          "You must allow pop-ups in your browser to successfully open the payment window. (We recommend using a web browser or the Chrome app)",
        pay: "Pay",
        failedToOpenPaymentWindow:
          "We were unable to open the payment window. This might be due to your browser blocking pop-ups or a network issue. Please enable pop-ups and try again!",
        successResultPageDescription:
          "Your payment has been processed successfully.\n Please click the button below to return to \nthe previous page and continue.",
        failedResultPageDescription:
          "Your payment could not be processed. \nPlease return to the previous page and try the payment again.",
        loadingResultPageDescription: "Please wait while we process your payment...",
        returnToPreviousPage: "Return to previous page",
        failedToProcessPayment: "Failed to process payment. Please try again later.",
        invalidRequestData: "Invalid request. Please check your information and try again.",
        welcomeTo82Office: "🎉 Welcome to 82 Office!",
        welcomeDescription:
          "Your membership registration has been successfully completed. You are now an official member of 82 Office Silicon Valley and can enjoy a variety of premium services.\n\n📩 Information about how to use the space, membership benefits, and additional support will be sent sequentially to the email address you provided during registration\n\nWe’re excited to be part of your new global business journey.\n82 Office is here to support your growth.",
        returnToMain: "Return to main",
      },
    },
    welcome: "Welcome to 82 Office",
    mainPage: "Main Page",
    heroTitle: "Global Market Starts Here: \n82 Office",
    heroDescription: "Take your business to the next level\nin the heart of Silicon Valley.",
    profile: "Profile",
    membership: "Membership",
    reservations: "Reservations",
    contact: "Contact",
    credits: "Credits",
    monthlyCredits: "Monthly credits",
    creditsRemaining: "Credits remaining",
    hours: "{{count}} hours",
    hoursAndMinutes: "{{hours}} hours {{minutes}} minutes",
    myReservations: "My reservations",
    myPage: "My page",
    logout: "Logout",
    contactIntro: "If you need assistance or have any requests, please contact",
    contactEmail: "or fill out the contact form below.",
    wordLimit: "(200 word limit)",
    email: "Email",
    emailPlaceholder: "email@address.com",
    emailHelper: "The email address you enter will be used for our reply to your inquiry",
    emailRequired: "Please enter your email address.",
    emailInvalid: "Please enter a valid email address.",
    title: "Title",
    titleRequired: "Please enter a title.",
    message: "Message",
    messagePlaceholder: "Type in your question or inquiry",
    messageRequired: "Please enter your message.",
    messageMaxLength: "Message must be within 200 characters.",
    submit: "Submit",
    sending: "Sending...",
    sendSuccess: "Your message has been sent successfully.",
    sendError: "Failed to send your message. Please try again later.",
    notFoundTitle: "Sorry,\nthe page cannot be found",
    notFoundDescription: "We looked everywhere but couldn't find the\npage you're looking for.",
    goBackHome: "Go back home",
    loading: "Loading...",
    error: "An error occurred.",
    retry: "Try again",
    cancel: "Cancel",
    confirmed: "Confirmed",
    cancelled: "Cancelled",
    pending: "Pending",
    free: "Free",
    paid: "Paid",
    reservationHours_one: "{{count}} hour",
    reservationHours_other: "{{count}} hours",
    noReservations: "No reservations for this month.",
    timezoneLosAngeles: "(PST/PDT)",
    deleteReservationTitle: "Cancel this reservation?",
    deleteReservationDescription:
      "If you cancel on the day of the reservation, the used free credits or payment will not be refunded.",
    keepReservation: "Keep",
    cancelReservation: "Cancel reservation",
    reservationDeletedSuccess: "Reservation cancelled successfully",
    reservationDeleteFailed: "Failed to cancel reservation",
    pastReservation: "Cannot cancel a past reservation.",
    deletePaymentMethodTitle: "Are you sure?",
    deletePaymentMethodDescription: "If you proceed with this action, your current information will be deleted.",
    keepPaymentMethod: "Keep",
    deletePaymentMethod: "Delete",
    unsubscribeMembershipTitle: "Are you sure you?",
    unsubscribeMembershipDescription:
      "Your access and all benefits will be restricted immediately. You will no longer be able to make reservations or use the space.",
    unsubscribe: "Unsubscribe",
    goBack: "Go back",
    unsubscribeComplete: "Your membership has been successfully canceled.",
    unsubscriptionSuccess: "Membership unsubscription completed successfully",
    unsubscriptionFailed: "Failed to unsubscribe from membership",
    reservationPolicyTitle: "Reservation policy",
    commonReservationRules: "Common reservation rules",
    reservationMaxHoursPerDay: "You can only reserve 3 hours per day",
    silverMembership: "Silver Membership",
    silverNoSameDayReservation: "Same-day reservations not available",
    silverFreeHours: "Includes 5 complimentary hours per month",
    reservationUnavailableTitle: "Reservation unavailable",
    silverMembershipSameDayReservationNotAllowed: "SILVER membership cannot make same-day reservations.",
    onlySilverMembershipReservation: "Virtual Address/Day Pass membership cannot make reservations.",
    additionalUsageFee: "Additional usage fee",
    additionalFeeDescription:
      "An additional fee of $15 per 30 minutes will be charged for reservations exceeding the free hours.",
    meetingRoomReservations: "Meeting room reservations",
    reserveRoom: "Reserve room",
    myReservation: "My Reservation",
    reserved: "Reserved by another",
    meetingRoomAlreadyReservedTitle: "Time slot unavailable",
    meetingRoomAlreadyReservedDescription:
      "The selected time is currently unavailable.\nPlease choose another time slot.",
    reservationLimitReachedTitle: "Reservation limit reached",
    reservationLimitReachedDescription: "You already reached the daily 3 hour limit of your reservation.",
    ok: "OK",
    freeCredits: "Free credits",
    reservingHours: "Reserving hours",
    payment: "Payment",
    paymentLine: "0.5 hours ($15) x {{count}}",
    total: "Total",
    reservationDialogTitle: "Reservation",
    startTime: "Start time",
    endTime: "End time",
    selectTime: "Select time",
    selectStartTimeFirst: "Select start time first",
    reserve: "Reserve",
    reservationCreatedSuccess: "Reservation created successfully",
    reservationCreateFailed: "Failed to create reservation",
    invalidTimeRange: "Start time cannot be later than end time.",
    requiredFieldMissing: "Missing required fields.",
    invalidDateFormat: "Invalid date format. (YYYY-MM-DD)",
    invalidTimeFormat: "Invalid time format. (HH:mm)",
    paymentHistory: "Payment history",
    paymentItem_MEMBERSHIP: "Membership",
    paymentItem_MEETING_ROOM: "Meeting room",
    invoice: "Invoice",
    refunded: "(Refunded)",
    pageOf: "{{current}} / {{total}}",
    prev: "Prev",
    next: "Next",
    membershipPlan_SILVER: "Silver",
    membershipPlan_VIRTUAL_ADDRESS: "Virtual Address",
    membershipPlan_DAY_PASS: "Day Pass",
    billingCycle_MONTHLY: "Monthly",
    billingCycle_YEARLY: "Yearly",
    billingCycle_DAILY: "Daily",
    rateOf: "{{billingCycle}} rate of ${{amount}}",
    plan: "Plan",
    notSubscribedToPlan: "Not subscribed to a plan",
    applyNow: "Apply now",
    nextPaymentDate: "Next Payment Date:",
    paymentMethod: "Payment Method:",
    cardLast4: "Card ({{last4}})",
    settings: "Settings",
    paymentType: "Payment type",
    useAsMain: "Use as main",
    deleteCard: "Delete card",
    addCard: "Add card",
    paymentMethodUpdatedSuccess: "Payment method updated successfully",
    paymentMethodUpdateFailed: "Failed to update payment method",
    paymentMethodAddedSuccess: "Payment method added successfully",
    paymentMethodDeletedSuccess: "Payment method deleted successfully",
    paymentMethodDeleteFailed: "Failed to delete payment method",
    upgradePlan: "Upgrade plan",
    upgradePlanFailed: "Failed to upgrade plan",
    originalPlan: "Original plan",
    eligiblePlan: "Eligible plan",
    additionalPaymentSummary: "Additional payment summary:",
    remainingDaysLabel: "Remaining days ({{start}} ~ {{end}}): {{days}} days (①)",
    originalPlanPaidAmount: "Original plan paid amount: {{full}}×(①/{{cycleDays}}) = {{remaining}} (②)",
    newPlanProratedAmount: "New plan prorated amount: {{amount}}×(①/{{cycleDays}}) = {{prorated}} (③)",
    chargedAmount: "Charged amount: ③ - ② = {{charged}}",
    payAmount: "Pay ${{amount}}",
    selectPlan: "Select plan",
    main: "Main",
    representative: "Name",
    company: "Company",
    phone: "Phone number",
    membershipType: "Membership type",
    suiteNumber: "Suite number",
    membershipPeriod: "Membership period",
    upgradePlanPaymentSuccess: "Upgrade plan payment completed successfully",
    loggedOutSuccessfully: "Logged out successfully",
    signIn: "Sign in",
    membershipApplyNow: "Apply now",
    reserveRooms: "Reserve rooms",
    silverTourTitle: "Welcome to 82 Office!",
    silverTourDescription:
      "We'd love to show you around before you get started.\nBook a 15-minute tour and we'll walk you through!",
    silverTourCta: "Schedule my 15 min tour",
    silverTourHideForToday: "Don't show again today",
    room: "Room",
    // Admin view
    adminMembers: "Members",
    adminReservations: "Reservations",
    adminMembersTitle: "Members",
    adminReservationsTitle: "Reservations",
    adminSearchPlaceholder: "Search",
    adminFilterType: "Type",
    adminFilterStatus: "Status",
    adminColumnCompany: "Company",
    adminColumnType: "Type",
    adminColumnStatus: "Status",
    adminColumnPeriod: "Period",
    adminShowingRange: "Showing {{from}}-{{to}} of {{total}}",
    adminEmptyMembers: "No members found",
    adminLoading: "Loading...",
    adminLoadFailed: "Failed to load data. Please try again later.",
    adminMemberDetails: "Member details",
    adminContactInformation: "Contact information",
    adminPreviousPlanHistory: "Previous plan history",
    adminRepresentative: "Representative",
    adminEmail: "Email",
    adminPhoneNumber: "Phone number",
    adminClose: "Close",
    adminNoRooms: "No meeting rooms available",
    adminSelectRoom: "Select meeting room",
    memberType_SILVER_MONTHLY: "Silver (Monthly)",
    memberType_SILVER_YEARLY: "Silver (Yearly)",
    memberType_VIRTUAL_ADDRESS_MONTHLY: "Virtual Address (Monthly)",
    memberType_VIRTUAL_ADDRESS_YEARLY: "Virtual Address (Yearly)",
    memberType_DAY_PASS: "Day Pass",
    memberStatus_ACTIVE: "Active",
    memberStatus_EXPIRED: "Expired",
  },
};
